import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tooltipPlacement", "onCopy", "inputRef", "autoSelect", "buttonProps", "defaultValue", "error", "inputProps", "onChange", "onCopy", "required", "value", "valueWhenCopied", "use"];
import { callIfPossible } from '../../utils/functions';
import { Controllable } from '../Controllable';
import { useContext, memo } from 'react';
import { CopyButton } from '../CopyButton/CopyButton';
import { TextInput } from '../TextInput/TextInput';
import { MediaObject } from '../MediaObject/MediaObject';
import ShareInput from '../ShareInput/ShareInput';
import { filterProps } from '../../../utils/filterProps';
import { FieldsetContext } from '../../context/FieldsetContext';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledFlex = styled.div.withConfig({
  displayName: "CopyInput__StyledFlex",
  componentId: "sc-18yzb7k-0"
})(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  flex: 1,
  '& input': {
    borderTopRightRadius: theme.borderRadius['0'],
    borderBottomRightRadius: theme.borderRadius['0']
  }
}));
const StyledWrapper = styled.div.withConfig({
  displayName: "CopyInput__StyledWrapper",
  componentId: "sc-18yzb7k-1"
})(({
  theme
}) => ({
  '& button': {
    borderTopLeftRadius: theme.borderRadius['0'],
    borderBottomLeftRadius: theme.borderRadius['0'],
    borderLeft: theme.borderWidth['0']
  }
}));
const CustomMediaBodyComponent = ({
  children
}) => {
  return /*#__PURE__*/_jsx(StyledFlex, {
    children: children
  });
};
export const CopyInputComponent = _ref => {
  let {
      tooltipPlacement = 'bottom',
      onCopy,
      inputRef,
      autoSelect = true,
      buttonProps,
      defaultValue,
      error,
      inputProps,
      onChange,
      required,
      value,
      valueWhenCopied,
      use
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const handleCopyClick = evt => {
    callIfPossible(onCopy, evt);
  };
  const handleInputMouseDown = evt => {
    if (autoSelect) {
      evt.preventDefault();
      if (inputRef.current) inputRef.current.select();
    }
  };
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const {
    size: fieldSize,
    disabled: fieldDisabled
  } = useContext(FieldsetContext);
  const computedInputDisabled = (inputProps === null || inputProps === void 0 ? void 0 : inputProps.disabled) || fieldDisabled;
  const computedButtonDisabled = (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.disabled) || fieldDisabled;
  return /*#__PURE__*/_jsx(MediaObject, Object.assign({}, tokenProps, {
    spacing: "none",
    MediaBody: CustomMediaBodyComponent,
    itemRight: /*#__PURE__*/_jsx(StyledWrapper, {
      children: /*#__PURE__*/_jsx(CopyButton, Object.assign({
        onClick: handleCopyClick,
        targetInputRef: inputRef,
        size: fieldSize || 'md',
        tooltipPlacement: tooltipPlacement,
        value: value,
        valueWhenCopied: valueWhenCopied
      }, buttonProps, {
        disabled: computedButtonDisabled
      }))
    }),
    children: /*#__PURE__*/_jsx(TextInput, Object.assign({
      "aria-readonly": !defaultValue,
      error: error,
      inputRef: inputRef,
      onChange: onChange,
      onMouseDown: handleInputMouseDown,
      required: required,
      type: "text",
      value: value,
      use: use
    }, domProps, inputProps, {
      disabled: computedInputDisabled
    }))
  }));
};
export const CopyInput = ShareInput(Controllable( /*#__PURE__*/memo(CopyInputComponent)));